import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";
import crawler from "../assets/projects/crawler.png";
import dyslexia from "../assets/projects/dyslexia.png";
import meditron from "../assets/projects/meditron.jpg"
import devTinder from "../assets/projects/DevTinder.png"

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently. <br></br>
          <b>Backend of these applications are hosted on Render, so it may take upto 5 mins to cold start the server</b>
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={meditron}
              isBlog={false}
              title="Meditron"
              link={true}
              description="Meditron is a full-stack web app designed to streamline healthcare management. Built using the MERN stack, the app offers a range of features for patients, doctors, and administrators. It provides Appointment Booking, Prescription Management, User Management, Health History features to the user of the application "
              ghLink="https://medi-tron-frontend.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={devTinder}
              isBlog={false}
              title="Tinder for Dev"
              link={true}
              description="Dev Tinder is a project which connects different developer together so that they can get connected and work on cool stuff. This project is like a playground for me I use this project to learn and implement different things, currently I'm working on sockets and I have implemented live notifications which notifies the user when they get a request from other user and when there request get accepted, I will be implementing chats soon..."
              ghLink="https://devhive.jaii.in/"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={crawler}
              isBlog={false}
              title="Smart WebCrawler and Summarizer"
              description="A web crawling and relevancy search tool that identifies and returns related websites based on TF-IDF vectorization and cosine similarity, while also summarizing pages by extracting key information and filtering out unnecessary content."
              ghLink="https://github.com/VoidVampire/Smart-Crawler-and-Summarizer"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dyslexia}
              isBlog={false}
              title="Dyslexia Prediction using Handwriting"
              description="This project uses machine learning to predict dyslexia based on handwriting samples. Utilizing tesseract OCR engine and Levenstein distance for extracting spelling and gramatical mistakes, then using decision tree algorithm for classification which successfully identifies dyslexia with high accuracy of 96%."
              ghLink="https://github.com/Aman-Sharma-03/Dyslexia-Prediction"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default Projects